import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Logo from './Logo';
import SeletorDeIdioma from './SeletorDeIdioma';
import { lerPrefixo } from '../config/seo';
import { Link, useIdioma } from '../i18n';
import '../styles/Header.css';

/* Os alvos da proposta (`/features`, `/pricing`, `/contact`) não existem como
   rota: são seções da home. Eram `#features` puros, e fora da home — no blog,
   nos planos, nas páginas jurídicas — o clique procurava a seção na página
   atual, não achava e não fazia nada. Agora apontam para a home. */
const LINKS = [
  { to: '/#features', chave: 'site.recursos' },
  { to: '/#pricing', chave: 'site.precos' },
  { to: '/blog', chave: 'site.blog' },
  { to: '/#contact', chave: 'site.contato' }
];

/**
 * Na home, `/#pricing` só rola: o `Link` do router não rola até âncora
 * nenhuma. Em outra página, deixa navegar — a home rola ao chegar.
 */
export const rolarAteSecao = (evento, destino) => {
  const secao = destino.includes('#') && document.getElementById(destino.split('#')[1]);
  if (!secao) return;
  evento.preventDefault();
  secao.scrollIntoView({ behavior: 'smooth' });
};

/**
 * Header do site público.
 * `progress` (0–100) desenha a barra de leitura — usada nas páginas de artigo.
 */
const Header = ({ progress = null }) => {
  const { t } = useIdioma();
  const [open, setOpen] = useState(false);
  /* Sem o prefixo do idioma, para `/pt-br/blog` também marcar o Blog. */
  const { caminho: pathname } = lerPrefixo(useLocation().pathname);

  return (
    <header className={`header ${open ? 'is-open' : ''}`.trim()}>
      <div className="header-inner">
        <Link to="/" className="header-brand" onClick={() => setOpen(false)}>
          <Logo size={28} />
        </Link>

        <button
          type="button"
          className="header-burger"
          aria-expanded={open}
          aria-label={t('site.abrirMenu')}
          onClick={() => setOpen((v) => !v)}
        >
          <i />
          <i />
        </button>

        <nav className="header-nav">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={pathname.startsWith(l.to) ? 'is-active' : undefined}
              onClick={(e) => {
                setOpen(false);
                rolarAteSecao(e, l.to);
              }}
            >
              {t(l.chave)}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <SeletorDeIdioma />
          <Link to="/login" className="header-login">
            {t('site.entrar')}
          </Link>
          <Link to="/signup" className="sp-btn sp-btn-primary">
            {t('site.experimentar')}
          </Link>
        </div>
      </div>

      {progress !== null && (
        <div className="header-progress">
          <span style={{ width: `${Math.min(100, Math.max(0, progress))}%` }} />
        </div>
      )}
    </header>
  );
};

export default Header;
